module.exports = __webpack_public_path__ + "img/common.4be73fa3.png";